module.exports = __webpack_public_path__ + "static/media/frontend.e1e556ba.svg";